const siteObject = {
	name: 'Abstract Store',
	shortname: 'Abstract Store',
	href: '/',
	appID: import.meta.env.VITE_ABSTRACTSTORE_APPID || '',
	baseURL: import.meta.env.VITE_ABSTRACTSTORE_BASE_URL || window.location.origin,
	idBaseURL: import.meta.env.VITE_ABSTRACTSTORE_ID_BASE_URL || 'https://id.abstract3d.com',
	adminRole: import.meta.env.VITE_ABSTRACTSTORE_ADMIN_ROLE || 'ABSTRACTSTORE_ADMIN',
	backend: {
		baseURL: import.meta.env.VITE_ABSTRACTSTORE_BACKEND_URL || '',
		idBaseURL: import.meta.env.VITE_ABSTRACTSTORE_ID_BACKEND_URL || 'https://api.id.abstract3d.com',
		api: {
			configuration: '/api/configuration',
			userMe: '/api/user/me',
			userList: '/api/user/list',
			user: '/api/user',
			auditList: '/api/audit/list',

			// Configuration (Design §4.5, §13). Every one of these is admin-only.
			adminSettings: '/api/admin/settings',
			adminSetupStatus: '/api/admin/setup-status',
			adminPaymentProvider: '/api/admin/payment-provider',
			adminPaymentProviderTypes: '/api/admin/payment-provider/types',
			adminSecretsReEncrypt: '/api/admin/secrets/re-encrypt',
			adminCurrency: '/api/admin/currency',
			adminRefundPolicy: '/api/admin/refund-policy',
			adminTaxRate: '/api/admin/tax-rate',
			adminTaxIDFormat: '/api/admin/tax-id-format',
			adminSeller: '/api/admin/seller',
			adminClickwrap: '/api/admin/clickwrap',
			adminProductOption: '/api/admin/product-option',
			adminInvoice: '/api/admin/invoice',
			adminInvoices: '/api/admin/invoices',

			// Applications (Design §4.3, §13). The registry of who may read entitlement state, with
			// what scope, and under which key.
			adminApplication: '/api/admin/application',
			adminAbstractIDApplications: '/api/admin/abstractid/applications',
			// Delivery health (Design §8.1, §13). The replay hangs off an application rather than
			// off a delivery, because it resends *current state*, not a stored attempt.
			adminWebhookDeliveries: '/api/admin/webhook-deliveries',

			// Catalog authoring (Design §13).
			adminFamily: '/api/admin/family',
			// The order of the lines, and of the tiers inside one (§14). Both take the whole
			// visible order rather than an item and a position.
			adminFamilyReorder: '/api/admin/family/reorder',
			adminProductReorder: '/api/admin/product/reorder',
			adminMedia: '/api/admin/media',
			adminProduct: '/api/admin/product',
			adminPrice: '/api/admin/price',
			adminCoupon: '/api/admin/coupon',
			adminCatalogSync: '/api/admin/catalog/sync',

			// Email (Design §11, §13). The sender, the copy and the queue — every one of them an
			// admin action with an audit trail rather than a deployment.
			adminEmailProvider: '/api/admin/email-provider',
			adminEmailProviderTypes: '/api/admin/email-provider/types',
			adminEmailTemplates: '/api/admin/email-templates',
			adminEmailTemplate: '/api/admin/email-template',
			adminEmailMessages: '/api/admin/email-messages',

			// Storefront analytics (Design §12) — the reads. The collector the storefront writes
			// through lives with the storefront, in AbstractID.
			adminAnalytics: '/api/admin/analytics',
			// Financial reports (Design §13). Beside analytics rather than inside it: analytics
			// reads the visit log and answers "what did people do", this reads invoices, orders and
			// refunds and answers "what did the store take".
			adminReports: '/api/admin/reports',
			// §13. Migrating the legacy store. The **upload** is mounted outside the API router —
			// ahead of the body parser — but it is the same URL space, so it is listed here too.
			adminMigrationBatch: '/api/admin/migration/batch',
			adminMigrationMappingTargets: '/api/admin/migration/mapping-targets',
			adminMigrationLookup: '/api/admin/migration/lookup',
			adminCreditNote: '/api/admin/credit-note',

			// Operations (Design §13, §16). Nothing here blocks checkout, which is exactly why it
			// needs a screen: the inline reconcile keeps purchases completing with every worker
			// stopped, so these are the only numbers that move when the machinery dies.
			adminMetrics: '/api/admin/metrics',
			adminOperationsHealth: '/api/admin/operations/health',
			adminOperationsDeliveries: '/api/admin/operations/deliveries',
			adminProviderEvents: '/api/admin/provider-events',
			adminReconciliation: '/api/admin/reconciliation',
			adminCatalogSyncStatus: '/api/admin/catalog/sync-status',

			// Support and money out (Design §9.6, §13). A customer is addressed by the **user's**
			// uuid, because one customer is one user and it has no identifier of its own.
			adminCustomer: '/api/admin/customer',
			// Store-wide, as opposed to the per-customer lists on a customer's own page.
			adminSubscriptions: '/api/admin/subscriptions',
			adminOrders: '/api/admin/orders',
			// The detail screens behind those two lists.
			adminSubscription: '/api/admin/subscription',
			adminOrder: '/api/admin/order',
			adminRefund: '/api/admin/refund'
		}
	}
};

export default siteObject;
